import { useEffect, useState } from 'react';

export const useComponentSize = (ref: any) => {
  const [width, setWidth] = useState(ref?.current?.clientWidth);
  const [height, setHeight] = useState(ref?.current?.clientHeight);
  useEffect(() => {
    setWidth(ref?.current?.getBoundingClientRect().width);
    setHeight(ref?.current?.getBoundingClientRect().height);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref?.current?.getBoundingClientRect()]); // <-- this does not trigger on every resize

  return { width, height };
};
